import PropTypes from "prop-types";
import React from "react";

import "./SpotMarker.scss";

function TruckMarker({ status, data, onChangeActive }) {
  return (
    <a href={`#${data?.service_no}`}>
      <div className={`truck-marker-label${status === "active" ? "-active" : ""}`}>
        <div
          className="map-marker-label"
          onClick={() => onChangeActive(data)}
        >
          <span className="car-number">{data?.car_number || ""}</span>
          <span className="driver-name">{data?.driver_nm || ""}</span>
        </div>
        <div className="map-marker-con" />
        <div className="map-marker-pointer" />
      </div>
    </a>
  );
}

export default TruckMarker;

TruckMarker.propTypes = {
  status: PropTypes.string,
  data: PropTypes.object,
  onChangeActive: PropTypes.func
};
